import cn from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from '../../col';
import { Icon } from '../../icons';
import { RoundElement } from '../../round-element';
import { Row } from '../../row';
import { Text, Title } from '../../typography';
import styles from './empty-state.module.css';

type P = {
  className?: string;
  description?: ReactNode;
  filterName?: string;
  icon?: ReactNode;
  isFiltered?: boolean;
  name: ReactNode;
};

const EmptyState = ({ className, description, filterName, icon, isFiltered, name }: P) => {
  const { t } = useTranslation(['translationReactComponents']);
  const { t: translate } = useTranslation();
  const translatedFilterName = typeof filterName === 'string' ? translate(filterName).toLowerCase() : filterName;
  const translatedDescription = typeof description === 'string' ? translate(description) : description;
  const translatedName = typeof name === 'string' ? translate(name) : name;
  const titleFiltered =
    typeof filterName === 'string' ? t('emptyState.titleFiltered', { name: translatedFilterName }) : filterName;
  const title =
    typeof translatedName === 'string' ? t('emptyState.title', { name: translatedName.toLowerCase() }) : name;

  return (
    <Row align="middle" className={cn(styles.empty, className)} gutter={[0, 'lg']} justify="center">
      <Col flex="none" span={24}>
        <RoundElement size="medium">
          <Text type="secondary">
            {isFiltered ? (
              <Icon icon="search-2-line" size="large" />
            ) : (
              (icon ?? <Icon icon="inbox-2-line" size="large" />)
            )}
          </Text>
        </RoundElement>
      </Col>
      <Col flex="none" span={24}>
        <Title className={styles.title} level={5}>
          {isFiltered ? titleFiltered : title}
        </Title>
        <Text>
          {isFiltered
            ? t('emptyState.descriptionFiltered')
            : (translatedDescription ?? t('emptyState.description', { name: translatedName }))}
        </Text>
      </Col>
    </Row>
  );
};

export default EmptyState;
